/**
 * Created by mateimisarca on 25.03.2021
 */

import SeriesAdminPage from './series-admin-page';

export default SeriesAdminPage;
